import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Divider } from '@material-ui/core';
import { PANEL_VIEW } from '../SearchPanel/enum/searchPanelProps';
import { CONTAINER_MAX_WIDTH } from '../Container/props/containerProps';
import { useGetCategoriesQuery } from '../../features/category/api/categoryApi';
import { setActiveMenuItem } from '../../shared/redux/commonSlice';
import * as CommonSelectors from '../../shared/redux/commonSelectors';
import Container from '../Container';
import SearchPanel from '../SearchPanel';
import MostSearched from '../MostSearched';
import MoreCategoryInCategory from '../MoreCategoryInCategory';
import MoreArticlesInCategory from '../MoreArticlesInCategory';
import ShortContact from '../ShortContact';
import AppFooter from '../AppFooter';
import Tabs from '../Tabs';
import Tab from '../Tabs/Tab';
import './pageView.scss';

interface ContainerProps {
  view: PANEL_VIEW;
  className?: string;
  showMoreCategoryInCategory?: boolean;
  showMoreArticlesInCategory?: boolean;
  showMostSearched?: boolean;
  showShortContact?: boolean;
  showMenu?: boolean;
  categoryId?: string;
}

const PageView: FC<ContainerProps> = (props) => {
  const dispatch = useDispatch();
  const activeMenuItem = useSelector(CommonSelectors.activeMenuItem);
  const { mainCategories, isSuccess, isFetching } = useGetCategoriesQuery(
    {},
    {
      selectFromResult: (result) => {
        const rootCategory = result.data?.find((category) => {
          return !category.parent;
        });

        return {
          ...result,
          mainCategories:
            result.data?.filter((category) => {
              return rootCategory
                ? rootCategory.subcategories.find((subcategory) => {
                    return subcategory.id === category.id;
                  })
                : false;
            }) || [],
        };
      },
    },
  );
  useEffect(() => {
    if (!activeMenuItem && isSuccess && mainCategories.length > 0) {
      dispatch(setActiveMenuItem(mainCategories[0].id));
    }
  }, [isFetching]);

  return (
    <>
      <section className="PageView-Wrapper">
        <Container maxWidth={CONTAINER_MAX_WIDTH.LG}>
          <SearchPanel view={props.view} className="Without-Menu" />
          {props.showMenu && !!mainCategories.length && activeMenuItem && (
            <Tabs selected={activeMenuItem}>
              {mainCategories.map(({ id, name }) => {
                return <Tab label={name} value={id} key={id} />;
              })}
            </Tabs>
          )}
        </Container>
      </section>
      <section className={'PageView-Content ' + props.className}>
        <Container maxWidth={CONTAINER_MAX_WIDTH.LG}>{props.children}</Container>
      </section>
      <section className="PageView-Footer">
        <Container maxWidth={CONTAINER_MAX_WIDTH.LG}>
          <Divider className="ArticleShow-Divider" />
          {props.showMoreCategoryInCategory && props.categoryId && (
            <MoreCategoryInCategory categoryId={props.categoryId} />
          )}
          {props.showMoreArticlesInCategory && props.categoryId && (
            <MoreArticlesInCategory categoryId={props.categoryId} />
          )}
          {props.showMostSearched && <MostSearched />}
        </Container>
      </section>
      {props.showShortContact && <ShortContact />}
      <Container maxWidth={CONTAINER_MAX_WIDTH.LG}>
        <AppFooter />
      </Container>
    </>
  );
};

export default PageView;
